// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610070336/js/" + chunkId + "." + {"44":"d920b7bb","225":"ef815c56","481":"f5d9b16f","486":"6f4bc7fa","770":"591f7e0d"}[chunkId] + ".0.6120488452549924.chunk.js";
};